var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"players":_vm.players,"playerView":_vm.playerView,"playerinput":_vm.playerinput,"onsave":_vm.onsave,"showsave":_vm.showsave,"showtitle":_vm.showtitle}})}
var staticRenderFns = []

export { render, staticRenderFns }